<template>
    <div class="text-center" style="margin: 20px;">
      <v-icon 
        v-if="$vuetify.theme.dark" 
        @click="toggleTheme" 
        class="theme-icon"
      >
        mdi-weather-sunny
      </v-icon>
      <v-icon 
        v-else 
        @click="toggleTheme" 
        class="theme-icon"
      >
        mdi-weather-night
      </v-icon>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ThemeStatusFlow',
    methods: {
      toggleTheme() {
        // Alterna o estado do tema entre claro e escuro
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
        
        // Atualiza o localStorage com o estado atual
        localStorage.setItem('darkMode', this.$vuetify.theme.dark);
  
        // Atualiza o fundo do body com base no estado do tema
        this.updateBodyBackground();
      },
      updateBodyBackground() {
        // Define as cores do body dinamicamente
        if (this.$vuetify.theme.dark) {
          document.body.style.backgroundColor = '#121212'; // Fundo escuro
          document.body.style.color = '#ffffff'; // Texto claro
        } else {
          document.body.style.backgroundColor = '#ffffff'; // Fundo claro
          document.body.style.color = '#000000'; // Texto escuro
        }
      },
    },
    created() {
      // Carrega o tema salvo no localStorage ao iniciar o componente
      const savedTheme = localStorage.getItem('darkMode');
      this.$vuetify.theme.dark = savedTheme === 'true';
  
      // Atualiza o fundo do body com base no tema carregado
      this.updateBodyBackground();
    },
  };
  </script>
  
  <style scoped>
  .theme-icon {
    font-size: 24px !important;
    cursor: pointer;
    transition: transform 0.3s;
  }
  
  .theme-icon:hover {
    transform: scale(1.2);
  }
  </style>
  